export default "__VITE_ASSET__DAS2HhXN__"